import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CentroComercialComponent } from '../centro-comercial/centro-comercial.component';
import { ListaCentrosComercialesComponent } from '../lista-centros-comerciales/lista-centros-comerciales.component';

@Component({
  selector: 'app-evento',
  templateUrl: './evento.component.html',
  styleUrls: ['./evento.component.scss'],
})
export class EventoComponent implements OnInit {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    public dialogRefEvento: MatDialogRef<EventoComponent>
  ) {}

  ngOnInit(): void {}

  openMallModal() {
    const dialogRef = this.dialog.open(CentroComercialComponent, {
      width: '700px',
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
    this.dialogRefEvento.close();
  }
  onCancel(): void {
    this.dialogRefEvento.close();
  }

  openListMallModal() {
    const dialogRef = this.dialog.open(ListaCentrosComercialesComponent, {
      width: '700px',
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
    this.dialogRefEvento.close();
  }
}
